import types from './types';
import create from '~/misc/create';

import HTTPError from '~/misc/HTTPError';
import {promiseAction, ActionError} from '~/misc/dispatch';
import * as api from './api';

export const creditCardInfo = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.CREDIT_CARD_INFO,
  api.creditCardInfoApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
);

export const setDefaultCardAction = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.SET_DEFAULT_CARD,
  api.setDefaultCardApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
);

export const deleteCardAction = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.DELETE_CARD,
  api.deleteCardApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
);

export const addCardAction = (dispatch, getState, val) => promiseAction(
  dispatch,
  getState,
  types.ADD_CARD,
  api.addCardApi(getState, val).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const errorMessage = body.state_message;
      throw new ActionError(errorMessage);
    });
  })
).then(() => creditCardInfo(dispatch, getState, val));

export const hideAsyncErrorMessage = (dispatch, val) =>
  dispatch(create(types.PAYMENT_SETTING_PAGE_ASYNG_ERROR_HIDE, val));



// WEBPACK FOOTER //
// ./src/modules/paymentSettingPage/actions.js